<template>
  <div class="" style="background: #efefef;">
    <Header></Header>
    <div class="flex mL15 mt15 mr15 mb15"
         v-loading.fullscreen.lock="fullscreenLoading"
         >
      <div style="padding: 20px;width: 100%;" class="mr10 rad10 bg-f">
        <div class="flex">
          <div style="flex: 2" class="pt20">
            <el-tooltip effect="dark" :content="totalWealthDivTip" placement="bottom-start" :disabled='!showLast'>
              <div class="fl mr50 mb50" style='width: 300px'>
                <div class="fl imgBg"><img src="../../static/images/money.png" /></div>
                <span class="fb mL10">{{ wealthTitle }}</span>
                <el-tooltip effect="dark" :content="totalWealthTooltip2" placement="top-start">
                  <i class="el-icon-warning ml-5"></i>
                </el-tooltip>
                <br />
                <el-tooltip effect="dark" :content="totalWealthTooltip" placement="bottom-start">
                  <span class="f28 mL10 mt5 inline-block"
                        v-bind:style='this.totalWealth > this.userTotalWealth ? "color: rgba(146,208,80,1);" : "color: rgba(255,192,0,1)"'>{{ this.$customToMoney(this.totalWealth.toFixed(0)) }}</span>
                </el-tooltip>
                <span class='f20 mL5' v-show='showLast'>{{ this.totalWealthDiff }}</span>
                <br />
                <span class="f18 mL10 mt5 inline-block">目标：{{ this.$customToMoney(this.userTotalWealth.toFixed(0)) }}</span>
              </div>
            </el-tooltip>
            <div class="fl mb50 mr50" style='width: 250px'>
              <div class="fl imgBg"><img src="../../static/images/person.png" style="margin: 10px;" /></div>
              <span class="fb mL10">退休后月收入</span>
              <el-tooltip effect="dark" :content="aveIncomeTooltip2" placement="top-start">
                <i class="el-icon-warning ml-5"></i>
              </el-tooltip>
              <br />
              <el-tooltip effect="dark" :content="aveIncomeTooltip" placement="bottom-start">
                <span class="f28 mL10 mt5 inline-block"
                      v-bind:style='this.aveIncome > this.userAveIncome ? "color: rgba(146,208,80,1);" : "color: rgba(255,192,0,1)"'>{{ this.$customToMoney(this.aveIncome.toFixed(0))}}</span>
              </el-tooltip>
              <span class='f20 mL5' v-show='showLast'>{{ this.aveIncomeDiff }}</span>
              <br />
              <el-tooltip effect="dark" :content="aveIncomeDivTip" placement="bottom-start" >
                <span class="f18 mL10 mt5 inline-block">目标：{{ this.$customToMoney(this.userAveIncome.toFixed(0))}}</span>
              </el-tooltip>
          </div>
              <div class="fl mr50" style='width: 200px'>
                <div class="fl imgBg"><img src="../../static/images/yield.png" style="width: 35px;margin: 13px;" /></div>
                <span class="fb mL10">养老金替代率</span>
                <el-tooltip effect="dark" :content="replacementRateTooltip2" placement="top-start">
                  <i class="el-icon-warning ml-5"></i>
                </el-tooltip>
                <br />
<!--                <el-tooltip effect="dark" :content="replacementRateTooltip" placement="bottom-start">-->
                <span class="f28 mL10 mt5 inline-block"
                      v-bind:style='this.replacementRate > this.userReplacementRate ? "color: rgba(146,208,80,1);" : "color: rgba(255,192,0,1)"'>{{ this.replacementRate}}%</span>
<!--                </el-tooltip>-->
                <span class='f20 mL5' v-show='showLast'>{{ this.replacementRateDiff }}%</span>
                <br />
                <el-tooltip effect="dark" :content="replacementRateDIvTip" placement="bottom-start" >
                  <span class="f18 mL10 mt5 inline-block">目标：{{ this.userReplacementRate}}%</span>
                </el-tooltip>
              </div>

            <!--            <div class="fl width-190">-->
<!--              <div class="fl imgBg"><img src="../../static/images/save.png" /></div>-->
<!--              <span class="fb mL10">目标达成率</span><br />-->
<!--              <span class="f28 mL10 mt5 inline-block">82%</span>-->
<!--            </div>-->
          </div>
<!--          <div id="imgChart" style="height: 0px;flex: 1; "></div>-->
        </div>
        <div class="leftMiddle">
          <p class="f20 fb">退休前财富积累概览
            <el-tooltip effect="dark" :content="wealthAccumulationTooltip" placement="top-start">
              <i class="el-icon-warning ml-5"></i>
            </el-tooltip>
          </p>
          <div id="wealthAccumulation" style="height: 330px;"></div>
        </div>
        <div class="mt15">
          <p class="f20 fb">退休后养老金领取金额
            <el-switch class='fr mr20' v-model='assetSwitch'></el-switch>
            <span class="f14 fr mr5">考虑通货膨胀后
              <el-tooltip effect="dark" :content="assetSwitchTooltip" placement="top-start">
                <i class="el-icon-warning ml-5"></i>
              </el-tooltip>
            </span>
          </p>
          <div id="assetAllocation" style="height: 270px;"></div>
        </div>
        <div class="mt15">
          <p class="f20 fb">资产配置比例
            <el-tooltip effect="dark" :content="investmentRatioTooltip" placement="top-start">
              <i class="el-icon-warning ml-5"></i>
            </el-tooltip>
          </p>
          <div id="investmentRatio" style="height: 270px;"></div>
        </div>
      </div>
<!--      <div style="width:340px" class="rad10">-->
<!--        <div class="wealth rad10 bg-f mb10">-->
<!--          <p class="f20 mb10 fb">财富规划设置</p>-->
<!--          <div class="block" v-for="(item, key) in wealthList" :key="key">-->
<!--            <span class="demonstration fb">{{item.name}}</span>-->
<!--            <el-tooltip effect="dark" :content="item.tooltip" placement="top-start">-->
<!--              <i class="el-icon-warning ml-5"></i>-->
<!--            </el-tooltip>-->
<!--            <el-slider v-model="item.value" @change="sliderChange(item, key)" :format-tooltip="handlDelta"></el-slider>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="pension rad10 bg-f mb10">-->
<!--          <p class="f20 mb15 fb">社保养老金设置</p>-->
<!--          <div class="mb10 selectDiv">-->
<!--            <span class="fb inline-block width-90">城市</span>-->
<!--            <el-select v-model="paramsData.city" placeholder="请选择" class="width-190" @change='inputChange'>-->
<!--              <el-option v-for="item in cities" :key="item.name" :label="item.name" :value="item.name"></el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="mb10">&ndash;&gt;-->
<!--&lt;!&ndash;            <span class="fb inline-block width-90">性别</span>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-button :class="genderButtonClass1" @click='genderSelected("male")'>男</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-button :class="genderButtonClass2" style="margin-left: 0;" @click='genderSelected("female")'>女</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="mb10 inputDiv">&ndash;&gt;-->
<!--&lt;!&ndash;            <span class="fb inline-block width-90">专项扣除</span>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-input v-model="specialDeductions" class="rad20 inline-block width-190" placeholder="请输入专项扣除"></el-input>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div class="mb10 numberYear">-->
<!--            <span class="fb inline-block width-90">实际缴费年限</span>-->
<!--            <el-input-number v-model="paramsData.currentSocialSecurityPaidYears" :min="0" :max="50" @change='inputChange'></el-input-number>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">当前余额</span>-->
<!--            <el-input v-model="paramsData.currentAccountBalanceP1" class="rad20 width-190" placeholder="请输入当前余额" @change='inputChange'></el-input>-->
<!--          </div>-->
<!--          <p class="f20 mb15 fb">补充养老储蓄福利设置</p>-->
<!--          <div class="mb10 inputDiv" v-if='hasP2Corporation'>-->
<!--            <span class="fb inline-block width-100">是/否税优-->
<!--&lt;!&ndash;              <el-tooltip effect="dark" :content="corporationP2Tooltip" placement="top-start">&ndash;&gt;-->
<!--&lt;!&ndash;                  <i class="el-icon-warning ml-5"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                </el-tooltip>&ndash;&gt;-->
<!--            </span>-->
<!--&lt;!&ndash;            <el-input v-model="paramsData.currentAccountBalanceP2" class="rad20 width-190" placeholder="请输入当前余额" @change='inputChange'></el-input>&ndash;&gt;-->
<!--            <el-checkbox v-model='paramsData.isCorporationP2' @change='inputChange'></el-checkbox>-->
<!--          </div>-->
<!--          <div class="mb10 inputDiv">-->
<!--            <span class="fb inline-block width-90">当前余额</span>-->
<!--            <el-input v-model="paramsData.currentAccountBalanceP2" class="rad20 width-190" placeholder="请输入当前余额" @change='inputChange'></el-input>-->
<!--          </div>-->
<!--          <div class="mb30 inputDiv">-->
<!--            <span class="fb inline-block width-90 fl mr5" style="margin-top: 3px;">缴费比例<br />(企业)</span>-->
<!--            <el-input v-model="paramsData.formattedMonthlyEmployerContributionRatioP2" class="rad20 width-190" @change='p2InputChange(0)'></el-input>-->
<!--&lt;!&ndash;            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt5"></el-slider>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 width-90">&ndash;&gt;-->
<!--&lt;!&ndash;              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-select>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="mb30 inputDiv">-->
<!--            <span class="fb inline-block width-90 fl mr5" style="margin-top: 3px;">缴费比例<br />(个人)</span>-->
<!--            <el-input v-model="paramsData.formattedMonthlyEmployeeContributionRatioP2" class="rad20 width-190" @change='p2InputChange(1)'></el-input>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90 fl">退休后领取<br />年数</span>-->
<!--            <el-input v-model="paramsData.selectedReceivingYearsP2" class="rad20 width-190" placeholder="请输入当前余额" @change='inputChange'></el-input>-->
<!--          </div>-->
<!--          <div class="mb15 selectDiv" style='display: inline-block'>-->
<!--            <span class="fb inline-block width-90">投资组合类型</span>-->
<!--            <el-select v-model="paramsData.portfolioExpectedReturnP2" placeholder="请选择" class="width-190" @change='inputChange'>-->
<!--              <el-option v-for="item in portfolioExpectedOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--          <p class="f20 mb10 fb" style='text-align:left'>个人养老金设置</p>-->
<!--          <div class="mb10 inputDiv" style="height: 70px;">-->
<!--            <span class="fb inline-block width-90 fl mr5">商业养老-->
<!--              <el-tooltip effect="dark" :content="actualMonthlyContributionP3Tooltip" placement="top-start">-->
<!--                <i class="el-icon-warning ml-5"></i>-->
<!--              </el-tooltip>-->
<!--              <br />(税优)<br />每月缴费</span>-->
<!--            <el-input v-model="paramsData.actualMonthlyContributionP3" class="rad20 width-190" placeholder="请输入当前余额" @change='inputChange'></el-input>-->
<!--&lt;!&ndash;            <el-slider v-model="annuityontribution" class="width-190 inline-block fl mt20"></el-slider>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt20"></el-slider>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 mt15 width-90">&ndash;&gt;-->
<!--&lt;!&ndash;              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-select>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">当前余额</span>-->
<!--            <el-input v-model="paramsData.currentAccountBalanceP3" class="rad20 width-190" placeholder="请输入当前余额" @change='inputChange'></el-input>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">领取年数</span>-->
<!--            <el-input v-model="paramsData.selectedReceivingYearsP3" class="rad20 width-190" placeholder="请输入当前余额" @change='inputChange'></el-input>-->
<!--          </div>-->
<!--          <div class="mb10 selectDiv">-->
<!--            <span class="fb inline-block width-90">投资类型</span>-->
<!--            <el-select v-model="paramsData.portfolioPreferenceP3" placeholder="请选择" class="width-190" @change='inputChange'>-->
<!--              <el-option v-for="item in portfolioPreferenceOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="mb10 selectDiv" style="height: 70px;">&ndash;&gt;-->
<!--&lt;!&ndash;            <span class="fb inline-block width-90 fl mr5">商业养老<br />(非税优)<br />投资额度</span>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt20"></el-slider>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 mt15 width-90">&ndash;&gt;-->
<!--&lt;!&ndash;              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-select>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="insure rad10 bg-f mb10" v-if='hasInsure'>-->
<!--          <p class="f20 mb10 fb">保险产品设置</p>-->
<!--          <div class="mb10 selectDiv">-->
<!--            <span class="fb inline-block width-90">保险产品</span>-->
<!--            <el-select v-model="paramsData.insureProductId" placeholder="请选择" class="width-150" @change='inputChange'>-->
<!--              <el-option v-for="item in insureProduceOptions" :key="item.id" :label="item.title" :value="item.id"></el-option>-->
<!--            </el-select>-->
<!--            <a class="inline-block" style='color: #e90a5b; margin-left: 10px' @click='openAddInsureDialog'>添加</a>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">起始领取年龄</span>-->
<!--            <el-input v-model="paramsData.startingAgeForBenefitCollectionB1" class="rad20 width-190" placeholder="请输入年龄" @change='inputChange' :disabled='insureInputDisabled'></el-input>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">年缴费金额</span>-->
<!--            <el-input v-model="paramsData.annualContributionAmountB1" class="rad20 width-190" placeholder="请输入金额" @change='inputChange' :disabled='insureInputDisabled'></el-input>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">已缴费年限</span>-->
<!--            <el-input v-model="paramsData.yearsOfContributionsMadeB1" class="rad20 width-190" placeholder="请输入" @change='inputChange' :disabled='insureInputDisabled'></el-input>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">总缴费年限</span>-->
<!--            <el-input v-model="paramsData.totalContributionPeriodB1" class="rad20 width-190" placeholder="请输入" @change='inputChange' :disabled='insureInputDisabled'></el-input>-->
<!--          </div>-->
<!--          <div class="mb15 inputDiv">-->
<!--            <span class="fb inline-block width-90">保障年龄</span>-->
<!--            <el-input v-model="paramsData.coverageAgeB1" class="rad20 width-190" placeholder="请输入年龄" @change='inputChange' :disabled='insureInputDisabled'></el-input>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="mb10 selectDiv">&ndash;&gt;-->
<!--&lt;!&ndash;            <span class="fb inline-block width-90">领取方式</span>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-select v-model="paramsData.collectionMethodB1" placeholder="请选择" class="width-190" @change='inputChange' :disabled='insureInputDisabled'>&ndash;&gt;-->
<!--&lt;!&ndash;              <el-option v-for="item in collectionMethodOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-select>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--        <el-button v-if='!dynamicCalculate' type='primary' style='width: 100%;' @click=getAllData(false)>计算</el-button>-->

<!--        &lt;!&ndash;        <div class="btns">&ndash;&gt;-->
<!--&lt;!&ndash;          <el-button class="base-bg co-f">养老策略规划</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-button class="base-bg co-f">产品策略匹配</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->
    </div>
    <div v-if="fullscreenLoading && showFullscreenButton" class="custom-loading">
      <el-button type="primary" @click='openIncomeDialog'>完善数据</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="60%" class="addInsureDialog" title='添加建议书'>
      <div v-for='item in insureCashTableUrls' class="mb15 ">
        <span class="fb inline-block" style='width: 20%'>建议书链接地址</span>
        <el-input v-model="item.url" class="rad20" style='width: 70%'></el-input>
      </div>
      <div style='text-align: center'>
        <el-button @click='urlAdd' style='width: 200px'>+</el-button>
      </div>
      <div slot="footer" class="ac">
        <el-button type="info" @click="closeAddInsureCashTableDialog"> 取消</el-button>
        <el-button type="primary" @click="addInsureCashTable"> 添加</el-button>
      </div>
    </el-dialog>
    <OptionButton style='z-index: 99999' ref='optionButton'
                  @incomeDialogConfirm='handleIncomeDialogConfirm'
                  @dialogConfirm='handleDialogConfirm'
                  @incomeDialogVisibleChange='handleIncomeDialogVisibleChange'
                  :resultParams.sync='blockData'
                  :incomeData.sync='incomeData'
                  :showButton.sync='fullscreenLoading'
                  :questionData.sync='this.routeData' :retirementAge.sync='retirementAge'></OptionButton>
    <CompleteDataDialog
      :dialogVisible.sync='completeDataDialogVisible' :currentAge.sync='routeData.currentAge'
      @dialogConfirm='handleCompleteDataDialogConfirm'
      @dialogVisibleChange='handleCompleteDataVisibleChange'></CompleteDataDialog>
  </div>
</template>

<script>
import Header from './Header.vue'
import OptionButton from './options/OptionButton.vue'
import CompleteDataDialog from './options/CompleteDataDialog.vue'
import { fuchsia } from 'mockjs/src/mock/random/color_dict'
export default{
  components: { Header, OptionButton, CompleteDataDialog },
  data () {
    return {
      salesFlag: false,
      dynamicCalculate: false,
      hasInsure: false,
      annuityontribution: 20,
      annuityontributionSelect: '',
      annuityontributionSelects: [],
      balance: '',
      year: 1,
      specialDeductions: '',
      genderButtonClass1: 'base-bg co-f',
      genderButtonClass2: '',
      selectedGender: '',
      cities: [],
      // wealthList: [
      //   // {name: '月储蓄比例', value: 30 ,key: 'monthlySavingRatio'},
      //   {name: '流动性资产比例', value: 35, key: 'demandDepositRatio',
      //     tooltip: '流动性较高的资产，例如活期存款，货币基金，短期理财产品等。'},
      //   {name: '固定收益型资产比例', value: 40, key: 'bondDominatedAssetRatio',
      //     tooltip: '国债、公司债，债券型基金等风险较低，收益较稳定的资产。'},
      //   {name: '权益型资产比例', value: 25, key: 'equityDominatedAssetRatio',
      //     tooltip:'上市公司股票和未上市公司股权等风险较高，收益较不稳定的资产基金等。'},
      //   // {name: '退休年龄', value: 65},
      // ],
      // sliderObj: {
      //   lockIdx: 2,
      //   lastLockKey: 0,
      // },
      insureProduceOptions: [],
      // collectionMethodOptions: [{
      //   'label': '月领', 'value': 1,
      // }, {
      //   'label': '年领', 'value': 2,
      // }],
      // option: {},
      // portfolioExpectedTotalOptions: [
      //   {label: '平稳收益组合', value: 'STABLE_INCOME_PORTFOLIO'},
      //   {label: '稳健成长组合', value: 'CONSERVATIVE_GROWTH_PORTFOLIO'},
      //   {label: '积极进取组合', value: 'AGGRESSIVE_GROWTH_PORTFOLIO'},
      //   {label: '稳健型投资组合', value: 'STABLE_INVESTMENT_PORTFOLIO'},
      //   {label: '平衡型投资组合', value: 'BALANCED_INVESTMENT_PORTFOLIO'},
      //   {label: '多元型投资组合', value: 'DIVERSIFIED_INVESTMENT_PORTFOLIO'}
      // ],
      // portfolioExpectedOptions: [],
      // portfolioPreferenceOptions: [
      //   {label: '养老保险型产品', value: '保险'},
      //   {label: '养老基金型产品', value: '基金'},
      //   {label: '养老理财型产品', value: '理财'},
      //   {label: '养老储蓄型产品', value: '储蓄'},
      // ],
      myChartData: [],
      getToken: '',
      resultParams: {
        "CITY": "北京",
        "EXISTING_SAVINGS_AMOUNT": 0,
        "INCOME_SUBJECT_TO_TAXATION": 0,
        "OTHER_INCOMES": 0,
        "ESTIMATED_SPENDING": 0,
        "ACTUAL_MONTHLY_CONTRIBUTION_P3": 0,
        "MONTHLY_EMPLOYEE_CONTRIBUTION_RATIO_P2": 0,
        "CURRENT_ACCOUNT_BALANCE_P3": 0,
        "MONTHLY_EMPLOYER_CONTRIBUTION_RATIO_P2":0,
        // "PORTFOLIO_EXPECTED_RETURN_P2": 0,
        "STABLE_INVESTMENT_PORTFOLIO_P2": 50/100,
        "BALANCED_INVESTMENT_PORTFOLIO_P2": 40/100,
        "DIVERSIFIED_INVESTMENT_PORTFOLIO_P2": 10/100,
        "CURRENT_SOCIAL_SECURITY_PAID_YEARS": 0,
        "CURRENT_ACCOUNT_BALANCE_P1": 0,
        "CURRENT_ACCOUNT_BALANCE_P2": 0,
        "SELECTED_RECEIVING_YEARS_P2": 0,
        "SELECTED_RECEIVING_YEARS_P3": 0,
        // "CURRENT_AGE": 25,
        // "GENDER": 'male',
        // "ANSWER1": this.routeData.answer1,
        // "ANSWER2": this.routeData.answer2,
        // "ANSWER3": this.routeData.answer3,
        // "ANSWER4": this.routeData.answer4,
        // "ANSWER5_1": this.routeData.answerYear,
        // "ANSWER5_2": this.routeData.answerMoney,
        // "IS_CORPORATION_P2": this.hasP2Corporation ? this.paramsData.isCorporationP2 : false,
        "MONTHLY_SAVING_RATIO": 0,
        "PORTFOLIO_PREFERENCE_P3": "理财",
        "DEMAND_DEPOSIT_RATIO": 35 / 100,
        "BOND_DOMINATED_ASSET_RATIO": 40 / 100,
        "EQUITY_DOMINATED_ASSET_RATIO": 25 / 100,
        "INSURANCE_PRODUCT_ID": -1,
        "STARTING_AGE_FOR_BENEFIT_COLLECTION_B1": 60,
        "ANNUAL_CONTRIBUTION_AMOUNT_B1": 0,
        "PENSION_BENEFIT_AMOUNT_B1": null,
        "YEARS_OF_CONTRIBUTIONS_MADE_B1": 0,
        "TOTAL_CONTRIBUTION_PERIOD_B1": 5,
        "COVERAGE_AGE_B1": 105,
        "COLLECTION_METHOD_B1": 1
      },
      routeData: {},
      data: {},
      retirementAge: 0,
      wealthTitle: '退休时财富规模',
      totalWealth: 0,
      userTotalWealth: 0,
      lastTotalWealth:0,
      aveIncome: 0,
      userAveIncome: 0,
      lastAveIncome: 0,
      replacementRate: 0,
      userReplacementRate: 0,
      lastReplacementRate: 0,
      showLast: false,
      totalWealthTooltip: '考虑通货膨胀影响后：',
      totalWealthTooltip2: '根据输入的收入支出信息以及长期资本市场假设对未来资产规模的预测',
      totalWealthDivTip: '增加未来财富规模的方法包括提高收入、减少支出或者增加高风险高收益资产比例等，提高补充养老缴费的同时会带来养老金以外财富的减少',
      aveIncomeTooltip: '考虑通货膨胀影响后：',
      aveIncomeTooltip2: '根据输入的基础信息、社保信息及长期资本市场假设预测在法定可退休年龄时的月退休金收入，包括社保，补充养老储蓄福利以及个人养老金。##考虑通货膨胀后，退休后月收入显示成相对于当前购买力的结果。目标的退休后月收入反映在选择的生活水平目标下需要达到的收入水平。',
      aveIncomeDivTip: '增加退休后月收入的方法包括提高收入、提高补充养老缴费，增加高风险高收益资产比例，以及购买个人养老金产品等',
      replacementRateTooltip: '税后替代率：',
      replacementRateTooltip2: '替代率是指预测在法定可退休年龄时的月退休金收入与退休前月收入的比例。根据国际经验，要过上基础，舒适，富足和奢侈的养老生活，分别需要55%，70%，90%和110%的替代率',
      replacementRateDIvTip: '增加养老金替代率的方法包括提高收入、提高补充养老缴费，增加高风险高收益资产比例，以及购买个人养老金产品等',
      wealthAccumulationTooltip: '财富规模不包括养老金',
      investmentRatioTooltip: '根据全国不同年龄段家庭财富配置比例自动生成基于年龄的资产配置变化趋势。随着年龄的增长，风险接受程度逐步降低。仅供参考。',
      actualMonthlyContributionP3Tooltip: '每年上限12000，超过部分自动参与税优计算',
      corporationP2Tooltip: '企/职业年金享有税收优惠',
      assetSwitchTooltip: '由于通货膨胀，未来养老金收入的实际购买力会逐年下降，剔除通货膨胀影响的养老金等同于未来物价水平不变的情景下可领取的金额。',
      currentAccountBalanceP1Tooltip: '可在支付宝查询社保养老金获得该信息',
      assetSwitch: true,
      dialogVisible: false,
      hasP2Corporation: true,
      insureCashTableUrls: [{'url': ''}],
      fullscreenLoading: true,
      customerInfo: {},
      questionnaire: {},
      incomeData: {
        'EXISTING_SAVINGS_AMOUNT': 0,
        'INCOME_SUBJECT_TO_TAXATION': null,
        'OTHER_INCOMES': 0,
      },
      // 用于实例化block参数
      // 每个block对应固定的index
      // 当前版本每个index对应一个block对象，后续增加累计时对应一个block列表
      // index  |block type         |
      // 0      |Expenses           |支出
      // 1      |Investment         |投资
      // 2      |PublicPension      |社保
      // 3      |EnterpriseAnnuity  |企业补充养老
      // 4      |PrivatePension     |个人养老
      // 5      |InsuranceProduct   |保险产品
      blockData: [
        {
          // 0      |Expenses           |支出
          'component_type': 'Expenses',
          'ESTIMATED_SPENDING': 0
        },{
          // 1      |Investment         |投资
          'component_type': 'Investment',
          'MONTHLY_SAVING_RATIO': 0,
          'DEMAND_DEPOSIT_RATIO': 50/100,
          'BOND_DOMINATED_ASSET_RATIO': 40/100,
          'EQUITY_DOMINATED_ASSET_RATIO': 10/100
        },{
          // 2      |PublicPension      |社保
          'component_type': 'PublicPension',
          'CITY': '北京',
          'CURRENT_SOCIAL_SECURITY_PAID_YEARS': 0,
          'CURRENT_ACCOUNT_BALANCE_P1': 0
        },{
          // 3      |EnterpriseAnnuity  |企业补充养老
          'component_type': 'EnterpriseAnnuity',
          'CURRENT_ACCOUNT_BALANCE_P2': 0,
          'MONTHLY_EMPLOYER_CONTRIBUTION_RATIO_P2': 0,
          'MONTHLY_EMPLOYEE_CONTRIBUTION_RATIO_P2': 0,
          'SELECTED_RECEIVING_YEARS_P2': 20,
          'IS_CORPORATION_P2': false,
          'STABLE_INVESTMENT_PORTFOLIO_P2': 50/100,
          'BALANCED_INVESTMENT_PORTFOLIO_P2': 40/100,
          'DIVERSIFIED_INVESTMENT_PORTFOLIO_P2': 10/100
        },{
          // 4      |PrivatePension     |个人养老
          'component_type': 'PrivatePension',
          'ACTUAL_MONTHLY_CONTRIBUTION_P3': 0,
          'CURRENT_ACCOUNT_BALANCE_P3': 0,
          'SELECTED_RECEIVING_YEARS_P3': 20,
          'PORTFOLIO_PREFERENCE_P3': '保险'
        },{
          // 5      |InsuranceProduct   |保险产品
          'component_type': 'PrivatePension1',
          'STARTING_AGE_FOR_BENEFIT_COLLECTION_B1': 0,
          'ANNUAL_CONTRIBUTION_AMOUNT_B1': 0,
          'PENSION_BENEFIT_AMOUNT_B1': 0,
          'YEARS_OF_CONTRIBUTIONS_MADE_B1': 0,
          'TOTAL_CONTRIBUTION_PERIOD_B1': 0,
          'COVERAGE_AGE_B1': 0,
          'COLLECTION_METHOD_B1': 1,
        }
      ],
      blockEnabled: [
        false, false, false, false, false, false
      ],
      showFullscreenButton: true,
      completeDataDialogVisible: false
    }
   },
  computed: {
    token () {
      return this.$store.getters.getToken
    },
    totalWealthDiff () {
      let val = this.totalWealth - this.lastTotalWealth
      return val >= 0 ? '+' + this.$customToMoney(val.toFixed(0)) : this.$customToMoney(val.toFixed(0))
    },
    aveIncomeDiff () {
      let val = this.aveIncome - this.lastAveIncome
      return val >= 0 ? '+' + this.$customToMoney(val.toFixed(0)) : this.$customToMoney(val.toFixed(0))
    },
    replacementRateDiff () {
      let val = this.replacementRate - this.lastReplacementRate
      return val >= 0 ? '+' + String(val) : String(val)
    },
    // insureInputDisabled () {
    //   return this.resultParams["INSURANCE_PRODUCT_ID"] === -1
    // }
  },
  mounted () {

    this.dynamicCalculate = window._env_.dynamic_calculate || false
    this.hasInsure = window._env_.has_insure || false
    this.hasP2Corporation = window._env_.has_p2_corporation || false
    // var envOptions = window._env_.portfolio_expected_options || ['STABLE_INCOME_PORTFOLIO', 'CONSERVATIVE_GROWTH_PORTFOLIO', 'AGGRESSIVE_GROWTH_PORTFOLIO']
    // this.portfolioExpectedOptions = this.portfolioExpectedTotalOptions.filter( (item) => {
    //   return envOptions.indexOf(item.value) !== -1
    // })
    this.getToken = this.token === '' ? localStorage.getItem('token') : this.token
    this.salesFlag = localStorage.getItem('sales_flag')
    if (this.salesFlag === 'true') {
      if (Object.keys(this.$route.params).length !== 7) {
        this.$router.push({name: 'ClientManage'})
        return
      }
      const router_params = this.$route.params
      this.routeData = {
        answer1: router_params.ANSWER1,
        answer2: router_params.ANSWER2,
        answer3: router_params.ANSWER3,
        answer4: router_params.ANSWER4,
        currentAge: router_params.age,
        gender: router_params.gender,
        answerMoney: 0,
        answerYear: 0
      }
      this.blockData[2].CITY = router_params.city
    } else {
      if (Object.keys(this.$route.params).length !== 8) {
        this.$router.push({name: 'KnowYou'})
        return
      }
      const router_params = this.$route.params
      this.routeData = {
        answer1: router_params.ANSWER1 || '中性',
        answer2: router_params.ANSWER2 || '5-10年',
        answer3: router_params.ANSWER3 || '第一个投资产品',
        answer4: router_params.ANSWER4 || '舒适',
        currentAge: router_params.age || 30,
        gender: router_params.gender || 'male',
        answerMoney: router_params.answerMoney || 0,
        answerYear: router_params.answerYear || 0
      }
    }
    // this.resetData()

    this.customerInfo = {
      'CURRENT_AGE': this.routeData.currentAge,
      'GENDER': this.routeData.gender,
    }
    this.questionnaire = {
      'ANSWER1': this.routeData.answer1,
      'ANSWER2': this.routeData.answer2,
      'ANSWER3': this.routeData.answer3,
      'ANSWER4': this.routeData.answer4,
      'ANSWER5_1': this.routeData.answerYear,
      'ANSWER5_2': this.routeData.answerMoney,
    }
    this.blockData[2]['CURRENT_SOCIAL_SECURITY_PAID_YEARS'] = this.routeData.currentAge >= 25 ? this.routeData.currentAge - 25 : 0
    // this.resultParams = {
    //   ...this.resultParams,
    //   "CURRENT_AGE": this.routeData.currentAge,
    //   "GENDER": 'male',
    //   "ANSWER1": this.routeData.answer1,
    //   "ANSWER2": this.routeData.answer2,
    //   "ANSWER3": this.routeData.answer3,
    //   "ANSWER4": this.routeData.answer4,
    //   "ANSWER5_1": this.routeData.answerYear,
    //   "ANSWER5_2": this.routeData.answerMoney,
    //   "IS_CORPORATION_P2": this.hasP2Corporation ? this.resultParams["IS_CORPORATION_P2"] : false,
    //   "CURRENT_SOCIAL_SECURITY_PAID_YEARS": paid_years,
    //   "CURRENT_ACCOUNT_BALANCE_P1": this.resultParams["INCOME_SUBJECT_TO_TAXATION"] * paid_years * 12 * 0.08,
    // }
    this.wealthTitle = '未来' + this.routeData.answerYear + '年财富规模'

  },
  watch: {
    assetSwitch(val, oldVal) {
      this.drawAssetAllocationChart()
    }
  },
  methods: {
    getAllData (val) {
      const url = this.$api.Result1
      const blockData = this.blockData.filter( (item, index)=> {
        if (this.blockEnabled[index]){
          return item
        }
      })
      const params = {
        'customer_info_model': this.customerInfo,
        'questionnaire': this.questionnaire,
        'income_model': this.incomeData,
        'request':{
          'components': blockData
        }
      }

      this.$http.post(url, params, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          this.data = res.data
          this.lastTotalWealth = this.data['est_total_wealth_after_n_years_without_p2']
          this.totalWealth = this.data['est_total_wealth_after_n_years']
          this.userTotalWealth =this.data['target_wealth_after_n_years']
          this.lastAveIncome = this.data['est_ave_income_before_tax_without_p2']
          this.aveIncome = this.data['est_ave_income_before_tax']
          this.userAveIncome = this.data['target_ave_income_before_tax']
          this.lastReplacementRate = (this.data['replacement_rate_before_tax_without_p2'] * 100).toFixed(0)
          this.replacementRate = (this.data['replacement_rate_before_tax'] * 100).toFixed(0)
          this.userReplacementRate = (this.data['target_replacement_rate'] * 100).toFixed(0)
          this.totalWealthTooltip = '以当前购买力折算：' + this.$customToMoney(this.data['valued_total_wealth_after_n_years'].toFixed(0))
          this.aveIncomeTooltip = '以当前购买力折算：' + this.$customToMoney(this.data['valued_ave_income_before_tax'].toFixed(0))
          this.replacementRateTooltip = '税后替代率：' + (this.data['replacement_rate_after_tax'] * 100).toFixed(0) + '%'
          this.retirementAge = this.data['retirement_age']

          this.refreshReceivingYears()
          this.refreshPage()
          this.fullscreenLoading = false
          if (this.lastTotalWealth !== this.totalWealth) {
            this.showLast = true
          }
        }
      })
    },
    getScore () {
      let score = 0
      switch (this.routeData.answer1) {
        case "保守":
          score += 2
          break
        case "中性":
          score +=4
          break
        case "激进":
          score +=6
          break
        default:
          break
      }
      switch (this.routeData.answer2) {
        case "1-3年":
          score += 2
          break
        case "5-10年":
          score += 4
          break
        case "10年以上":
          score += 6
          break
        default:
          break
      }
      switch (this.routeData.answer3) {
        case "第一个投资产品":
          score += 3
          break
        case "第二个投资产品":
          score += 6
          break
        default:
          break
      }
      switch (this.routeData.answer4) {
        case "基础":
          score += 2
          break
        case "舒适":
          score += 3
          break
        case "富足":
          score += 4
          break
        case "奢侈":
          score += 6
          break
        default:
          break
      }
      return score
    },
    refreshReceivingYears() {
      if (!this.blockEnabled[3]) {
        this.blockData[3]['SELECTED_RECEIVING_YEARS_P2'] = this.routeData.gender === 'male' ? 87 - this.retirementAge : 89 - this.retirementAge
      }
      if (!this.blockEnabled[4]) {
        this.blockData[4]['SELECTED_RECEIVING_YEARS_P3'] = this.routeData.gender === 'male' ? 87 - this.retirementAge : 89 - this.retirementAge
      }
    },
    refreshPage() {
      let wealthChart = this.$echarts.init(document.getElementById('wealthAccumulation'),'light')
      let self = this
      wealthChart.setOption({
        grid: {
          bottom: 40,
          top: 30,
          right: 30
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: function (params) {
            var res = `${params[0]['axisValue']}<br/>`
            for (var item in params) {
              var value = self.$customToMoney(params[item].value.toFixed(0))
              res += `${params[item].marker}${params[item].seriesName}: ${value}<br/>`
            }
            return res
          }
        },
        toolbox: {
          feature: {
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: [
            '社保个人账户',
            '企业补充养老储蓄账户',
            '个人养老金账户',
            // '总养老金账户金额',
            '财富规模'
          ]
        },
        xAxis: [
          {
            name:'岁',
            type: 'category',
            data: this.data['accum_overview_data']['age_list'],
            // axisLabel: {
            //   interval: 0,
            //   rotate: 40
            // }
          }
        ],
        yAxis: [
          {
            type: 'value'
          },
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '社保个人账户',
            type: 'bar',
            stack: 'one',
            data: this.data['accum_overview_data']['account_amount_p1_data']
          },
          {
            name: '企业补充养老储蓄账户',
            type: 'bar',
            stack: 'one',
            data: this.data['accum_overview_data']['account_amount_p2_data']
          },
          {
            name: '个人养老金账户',
            type: 'bar',
            stack: 'one',
            data: this.data['accum_overview_data']['account_amount_p3_data']
          },
          {
            name: '财富规模',
            type: 'line',
            data: this.data['accum_overview_data']['total_wealth_data']
          }
        ]
      })
      this.drawAssetAllocationChart()
      var emphasisStyle = {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: 'rgba(0,0,0,0.3)'
        }
      }
      let investmentRatioChart = this.$echarts.init(document.getElementById('investmentRatio'), 'light')
      investmentRatioChart.setOption({
          legend: {
            data: ['流动性资产比例', '固定收益型资产比例', '权益型资产比例'],
          },
          toolbox: {
            feature: {
              saveAsImage: { show: true }
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            },
            formatter: function (params) {
              var res = `${params[0]['axisValue']}<br/>`
              for (var item in params) {
                var value = self.$customToMoney((params[item].value*100).toFixed(0)) + '%'
                res += `${params[item].marker}${params[item].seriesName}: ${value}<br/>`
              }
              return res
            }
          },
          xAxis: {
            data: this.data['investment_ratio_data']['age_list'],
            name: '岁'
          },
          yAxis: {
            max: 1,
            min: 0,
            axisLabel: {
              formatter: function (value) {
                return parseFloat(value) * 100 + '%'
              }
            }
          },
          grid: {
            bottom: 30,
            right: 30
          },
          series: [
            {
              name: '流动性资产比例',
              type: 'line',
              stack: 'total',
              emphasis: emphasisStyle,
              areaStyle: {},
              data: this.data['investment_ratio_data']['demand_deposit_ratio']
            },
            {
              name: '固定收益型资产比例',
              type: 'line',
              stack: 'total',
              emphasis: emphasisStyle,
              areaStyle: {},
              data: this.data['investment_ratio_data']['bond_dominated_deposit_ratio']
            },
            {
              name: '权益型资产比例',
              type: 'line',
              stack: 'total',
              emphasis: emphasisStyle,
              areaStyle: {},
              data: this.data['investment_ratio_data']['equity_dominated_deposit_ratio']
            }
          ]
        })
    },
    drawAssetAllocationChart() {
      let self = this
      let el = document.getElementById('assetAllocation')
      let assetAllocationChart = this.$echarts.getInstanceByDom(el)
      if (assetAllocationChart !== null && assetAllocationChart !== '' && assetAllocationChart !== undefined) {
        assetAllocationChart.dispose()
      }
      assetAllocationChart = this.$echarts.init(el, 'light')
      let xAxisData, data1, data2, data3, data4, data5
      if (this.assetSwitch) {
        xAxisData = this.data['valued_amount_withdrawal_data']['age_list']
        data1 = this.data['valued_amount_withdrawal_data']['income_at_retirement_year']
        data2 = this.data['valued_amount_withdrawal_data']['valued_income_after_retirement_p1_data']
        data3 = this.data['valued_amount_withdrawal_data']['valued_income_after_retirement_p2_data']
        data4 = this.data['valued_amount_withdrawal_data']['valued_income_after_retirement_p3_data']
        data5 = this.data['valued_amount_withdrawal_data']['valued_pension_benefit_after_retirement_b1_data']
      } else {
        xAxisData = this.data['amount_withdrawal_data']['age_list']
        data1 = this.data['amount_withdrawal_data']['income_at_retirement_year']
        data2 = this.data['amount_withdrawal_data']['income_after_retirement_p1_data']
        data3 = this.data['amount_withdrawal_data']['income_after_retirement_p2_data']
        data4 = this.data['amount_withdrawal_data']['income_after_retirement_p3_data']
        data5 = this.data['amount_withdrawal_data']['pension_benefit_after_retirement_b1_data']
      }
      // var _f = data5.filter( (item) => {
      //   return item !== 0
      // })
      var emphasisStyle = {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: 'rgba(0,0,0,0.3)'
        }
      };
      var legend_map = {
        'default': ['社保月收入', '企业补充养老储蓄月收入', '个人养老金月收入', '退休前月收入'],
        '1': ['社保月收入', '企业补充养老储蓄月收入', '个人养老金月收入', '退休前月收入', '商业养老保险月养老金', '商业养老保险月分红'],
        '2': ['社保月收入', '企业补充养老储蓄月收入', '个人养老金月收入', '退休前月收入', '身故或全残保险金保证利益', '身故或全残保险金红利利益'],
        '3': ['社保月收入', '企业补充养老储蓄月收入', '个人养老金月收入', '退休前月收入', '身故或全残保险金']
      }
      var series_map = {
        'default': [
          {'name': '社保月收入', 'key': 'valued_income_after_retirement_p1_data', 'income_after_key': 'income_after_retirement_p1_data'},
          {'name': '企业补充养老储蓄月收入', 'key': 'valued_income_after_retirement_p2_data', 'income_after_key':'income_after_retirement_p2_data'},
          {'name': '个人养老金月收入', 'key': 'valued_income_after_retirement_p3_data', 'income_after_key': 'income_after_retirement_p3_data'},
          {'name': '退休前月收入', 'key': 'income_at_retirement_year', 'income_after_key': 'income_at_retirement_year'}
        ],
        '1': [
          {'name': '社保月收入', 'key': 'valued_income_after_retirement_p1_data', 'income_after_key': 'income_after_retirement_p1_data'},
          {'name': '企业补充养老储蓄月收入', 'key': 'valued_income_after_retirement_p2_data', 'income_after_key':'income_after_retirement_p2_data'},
          {'name': '个人养老金月收入', 'key': 'valued_income_after_retirement_p3_data', 'income_after_key': 'income_after_retirement_p3_data'},
          {'name': '退休前月收入', 'key': 'income_at_retirement_year', 'income_after_key': 'income_at_retirement_year'},
          {'name': '商业养老保险月养老金', 'key': 'valued_pension_benefit_after_retirement_b1_data', 'income_after_key': 'pension_benefit_after_retirement_b1_data'},
          {'name': '商业养老保险月分红', 'key': 'valued_dividend_after_retirement_b1_data', 'income_after_key': 'dividend_after_retirement_b1_data'}
        ],
        '2': [
          {'name': '社保月收入', 'key': 'valued_income_after_retirement_p1_data', 'income_after_key': 'income_after_retirement_p1_data'},
          {'name': '企业补充养老储蓄月收入', 'key': 'valued_income_after_retirement_p2_data', 'income_after_key':'income_after_retirement_p2_data'},
          {'name': '个人养老金月收入', 'key': 'valued_income_after_retirement_p3_data', 'income_after_key': 'income_after_retirement_p3_data'},
          {'name': '退休前月收入', 'key': 'income_at_retirement_year', 'income_after_key': 'income_at_retirement_year'},
          {'name': '身故或全残保险金保证利益', 'key': 'valued_pension_benefit_after_retirement_b1_data', 'income_after_key': 'pension_benefit_after_retirement_b1_data'},
          {'name': '身故或全残保险金红利利益', 'key': 'valued_dividend_after_retirement_b1_data', 'income_after_key': 'dividend_after_retirement_b1_data'}
        ],
        '3': [
          {'name': '社保月收入', 'key': 'valued_income_after_retirement_p1_data', 'income_after_key': 'income_after_retirement_p1_data'},
          {'name': '企业补充养老储蓄月收入', 'key': 'valued_income_after_retirement_p2_data', 'income_after_key':'income_after_retirement_p2_data'},
          {'name': '个人养老金月收入', 'key': 'valued_income_after_retirement_p3_data', 'income_after_key': 'income_after_retirement_p3_data'},
          {'name': '退休前月收入', 'key': 'income_at_retirement_year', 'income_after_key': 'income_at_retirement_year'},
          {'name': '身故或全残保险金', 'key': 'valued_pension_benefit_after_retirement_b1_data', 'income_after_key': 'pension_benefit_after_retirement_b1_data'}
        ],
      }
      var graph_data
      if (this.assetSwitch) {
        graph_data = this.data['valued_amount_withdrawal_data']
      } else {
        graph_data = this.data['amount_withdrawal_data']
      }
      var key = [1, 2, 3].indexOf(this.resultParams.INSURANCE_PRODUCT_ID) === -1 ? 'default' : String(this.resultParams.INSURANCE_PRODUCT_ID)
      var data = series_map[key].map( (item) => {
        return {
          name: item.name,
          type: 'bar',
          stack: item.name === '退休前月收入' ? 'one': 'two',
          emphasis: emphasisStyle,
          data: this.assetSwitch ? graph_data[item.key] : graph_data[item.income_after_key]
        }
      })
      // console.log(key, data)
      let option = {

      }
      assetAllocationChart.setOption({
        legend: {
          data: legend_map[key]
        },
        toolbox: {
          feature: {
            saveAsImage: { show: true }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: function (params) {
            var res = `${params[0]['axisValue']}<br/>`
            for (var item in params) {
              var value = self.$customToMoney(params[item].value.toFixed(0))
              res += `${params[item].marker}${params[item].seriesName}: ${value}<br/>`
            }
            return res
          }
        },
        xAxis: {
          data: xAxisData,
          name: '岁',
          axisLabel:{
            interval: function(index, value) {
              return Number(value) % 2 === 1 || value === '54'
            },
            formatter: function(value, index) {
              // console.log(value)
              if ((self.customerInfo['GENDER'] === 'male' && value === '87') ||(self.customerInfo['GENDER'] === 'female' && value === '89')){
                return '{a|' + value + '}'
              } else {
                return value
              }
            },
            rich: {
              a: {
                color: 'red',
                fontSize: 18,
                fontWeight: 'bold'
              }
            }
          }
          //   textStyle: {
          //     color: function(value, index) {
          //       if ((self.customerInfo['GENDER'] === 'male' && value === '87') ||(self.customerInfo['GENDER'] === 'female' && value === '89')){
          //         return 'red'
          //       } else {
          //         return 'black'
          //       }
          //     },
          //     fontSize: function(value) {
          //       console.log(value)
          //       return 15
          //     }
          //   }
          // }
        },
        yAxis: {},
        grid: {
          bottom: 30,
          right: 30
        },
        series: data
      })
    },
    handlDelta (e) {
      return `${e}%`
    },
    // genderSelected(val) {
    //   if (val !== this.selectedGender){
    //     if (val === 'male'){
    //       this.genderButtonClass1 = 'base-bg co-f'
    //       this.genderButtonClass2 = ''
    //       this.selectedGender = 'male'
    //     } else {
    //       this.genderButtonClass1 = ''
    //       this.genderButtonClass2 = 'base-bg co-f'
    //       this.selectedGender = 'female'
    //     }
    //     this.getAllData()
    //   }
    // },
    // resetData(){
    //   this.city = '北京'
    //   this.wealthList = [
    //     // {name: '月储蓄比例', value: 30 ,key: 'monthlySavingRatio'},
    //     {name: '流动性资产比例', value: 35, key: 'demandDepositRatio',
    //       tooltip: '流动性较高的资产，例如活期存款，货币基金，短期理财产品等。'},
    //     {name: '固定收益型资产比例', value: 40, key: 'bondDominatedAssetRatio',
    //       tooltip: '国债、公司债，债券型基金等风险较低，收益较稳定的资产。'},
    //     {name: '权益型资产比例', value: 25, key: 'equityDominatedAssetRatio',
    //       tooltip:'上市公司股票和未上市公司股权等风险较高，收益较不稳定的资产基金等。'},
    //     // {name: '退休年龄', value: 65},
    //   ]
    //   this.sliderObj = {
    //     lockIdx: 2,
    //     lastLockIdx: 0,
    //   }
    //   this.selectedGender = 'male'
    //   this.paramsData = {
    //     // 财富规划设置
    //     // monthlySavingRatio: 30 / 100,
    //     demandDepositRatio: 35 / 100,
    //     bondDominatedAssetRatio: 40 / 100,
    //     equityDominatedAssetRatio: 25 / 100,
    //     // 社保养老金设置
    //     city: '北京',
    //     gender: 'male',
    //     currentSocialSecurityPaidYears: 1,
    //     currentAccountBalanceP1: 0,
    //     // 年金设置
    //     isCorporationP2: false,
    //     currentAccountBalanceP2: 0,
    //     monthlyEmployeeContributionRatioP2: 0,
    //     formattedMonthlyEmployeeContributionRatioP2: '0%',
    //     monthlyEmployerContributionRatioP2: 0,
    //     formattedMonthlyEmployerContributionRatioP2: '0%',
    //     selectedReceivingYearsP2: 20,
    //     portfolioExpectedReturnP2: this.portfolioExpectedOptions.length === 0 ? '' :this.portfolioExpectedOptions[0].value,
    //     // 个人年金设置
    //     actualMonthlyContributionP3: 0,
    //     currentAccountBalanceP3: 0,
    //     portfolioPreferenceP3: '理财',
    //     selectedReceivingYearsP3: 20,
    //     // 保险产品设置
    //     insureProductId: -1,
    //     startingAgeForBenefitCollectionB1: 60,
    //     AnnualContributionAmountB1: 0,
    //     yearsOfContributionsMadeB1: 0,
    //     totalContributionPeriodB1: 5,
    //     coverageAgeB1: 105,
    //     collectionMethodB1: 1
    //   }
    // },
    logout () {
      console.log('logout')
      this.$router.push({name: 'Login'})
    },
    inputChange () {
      if (this.dynamicCalculate){
        this.getAllData(false)
      }
    },
    p2InputChange (val) {
      var input = 0
      if (val === 0) {
        // 修改企业缴费比例
        input = this.paramsData.formattedMonthlyEmployerContributionRatioP2
        input = this.formatInput(input)
        this.paramsData.formattedMonthlyEmployerContributionRatioP2 = input
        this.paramsData.monthlyEmployerContributionRatioP2 = parseFloat(input.split('%')[0])
      } else if (val === 1) {
        // 修改个人缴费比例
        input = this.paramsData.formattedMonthlyEmployeeContributionRatioP2
        input = this.formatInput(input)
        this.paramsData.formattedMonthlyEmployeeContributionRatioP2 = input
        this.paramsData.monthlyEmployeeContributionRatioP2 = parseFloat(input.split('%')[0])
      }
      if (this.dynamicCalculate) {
        this.getAllData(false)
      }
    },
    formatInput(input) {
      let res = ''
      if (typeof input === 'string' && input.indexOf('%') !== -1) {
        if (input.indexOf('%') !== input.length - 1) {
          res = input.replace('%', '')
        } else {
          res = input
        }
      } else {
        res = input + '%'
      }
      return res
    },
    openAddInsureDialog () {
      if (this.paramsData.insureProductId !== -1){
        this.dialogVisible = true
      }
    },
    urlAdd () {
      this.insureCashTableUrls.push({'url': ''})
    },
    closeAddInsureCashTableDialog () {
      this.insureCashTableUrls = [{'url': ''}]
      this.dialogVisible = false
    },
    addInsureCashTable () {
      const url = this.$api.InsureCashTableAdd
      let cashUrls = this.insureCashTableUrls.map( (item) => {
        return item.url
      })
      const params= {
        'urls': cashUrls,
        'insureId': this.paramsData.insureProductId
      }
      this.$http.post(url, params, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
        if (res.status === 200) {
          this.closeAddInsureCashTableDialog()
        }
      })
    },

    sliderChange (item, idx) {
      const idxList = [0, 1, 2]
      let lockIdxList = [idx]
      let val = 100 - item.value
      if (this.sliderObj.lockIdx === idx){
        lockIdxList.push(this.sliderObj.lastLockIdx)
        val -= this.wealthList[this.sliderObj.lastLockIdx].value
      } else {
        lockIdxList.push(this.sliderObj.lockIdx)
        val -= this.wealthList[this.sliderObj.lockIdx].value
      }
      const changeIdx = idxList.filter(item => !lockIdxList.includes(item))[0]
      this.wealthList[changeIdx].value = val

      this.wealthList.forEach(item => {
        this.paramsData[item.key] = item.value / 100
      })
      if (this.sliderObj.lockIdx !== idx) {
        this.sliderObj.lastLockIdx = this.sliderObj.lockIdx
        this.sliderObj.lockIdx = idx
      }
      if (this.dynamicCalculate) {
        this.getAllData(false)
      }
      // this.myChartData = [
      //   {
      //     value: [1200, 2000, 40000, 15000, 30000],
      //     name: '收益属性'
      //   },
      //   {
      //     value: [6000, 18000, 18000, 20000, 12000],
      //     name: '现金流属性'
      //   },
      //   {
      //     value: [3000, 15000, 10000, 13000, 10000],
      //     name: '安全属性'
      //   }
      // ]
      // let myChart = this.$echarts.init(document.getElementById('imgChart'))
      // myChart.clear()
      // myChart.setOption({
      //   title: {
      //     text: 'Basic Radar Chart'
      //   },
      //   legend: {
      //     show: false
      //     // data: ['Allocated Budget', 'Actual Spending']
      //   },
      //   radar: {
      //     // shape: 'circle',
      //     indicator: [
      //       { name: '收益属性', max: 6500 },
      //       { name: '波动属性', max: 16000 },
      //       { name: '安全属性', max: 30000 },
      //       { name: '流动属性', max: 38000 },
      //       { name: '现金流属性', max: 52000 }
      //     ]
      //   },
      //   series: [
      //     {
      //       name: 'Budget vs spending',
      //       type: 'radar',
      //       data: this.myChartData
      //     }
      //   ]
      // })
    },
    openIncomeDialog () {
      this.showFullscreenButton = false
      this.completeDataDialogVisible = true
      // this.$refs.optionButton.incomeDialogVisible = true
    },
    handleDialogConfirm (index, data) {
      this.blockData[index] = Object.assign(this.blockData[index], data)
      this.blockEnabled[index] = true
      this.getAllData(true)
    },
    handleIncomeDialogConfirm (data) {
      this.incomeData = Object.assign(this.incomeData, data)
      this.blockData[2]['CURRENT_ACCOUNT_BALANCE_P1'] =
        this.blockData[2]['CURRENT_SOCIAL_SECURITY_PAID_YEARS'] * this.incomeData['INCOME_SUBJECT_TO_TAXATION'] * 12 *0.08
      this.getAllData(true)
    },
    handleIncomeDialogVisibleChange (val) {
      this.showFullscreenButton = !val
    },
    handleCompleteDataDialogConfirm (data) {
      this.incomeData = Object.assign(this.incomeData, data.incomeData)
      this.blockData[2]['CURRENT_ACCOUNT_BALANCE_P1'] =
        this.blockData[2]['CURRENT_SOCIAL_SECURITY_PAID_YEARS'] * this.incomeData['INCOME_SUBJECT_TO_TAXATION'] * 12 *0.08
      if (data.hasExpenses) {
        this.blockData[0] = Object.assign(this.blockData[0], data.expensesData)
        this.blockEnabled[0] = true
      }
      if (data.hasPublicPension) {
        this.blockData[2] = Object.assign(this.blockData[2], data.publicPensionData)
        this.blockEnabled[2] = true
      }
      this.getAllData(true)
    },
    handleCompleteDataVisibleChange (val) {
      this.completeDataDialogVisible = val
      this.showFullscreenButton = !val
    }
  }
}
</script>

<style>
.selectDiv .el-select .el-input .el-select__caret{
  line-height: 28px;
}
.inputDiv .el-input .el-input__inner{
  border-radius: 23px;
}
.numberYear .el-input .el-input__inner{
  border: transparent;
}
.numberYear .el-input-number .el-input-number__decrease.is-disabled,
.numberYear .el-input-number__increase,
.numberYear .el-input-number__decrease{
  height: 28px;
  line-height: 28px;
  background: #e90a5b;
  color: #fff;
}
.numberYear .el-input-number{
  width: 200px;
}
</style>
<style scoped>
.wealth{
  /*height: 280px;*/
  height: 200px;
  padding: 15px 20px;
}
.pension{
   padding: 15px 20px;
   /* height: calc(100% - 340px); */
   height: 740px;
}
.insure{
  /*height: 280px;*/
  height: 300px;
  padding: 15px 20px;
}
.pension>>>.el-input--suffix .el-input__inner,
.pension>>>.el-input__inner {
   height: 28px;
}
.pension>>>.el-button{
   height: 28px;
   line-height: 0;
   width: 98px;
}
.pension>>>.el-select>>>.el-input__inner{
   border-radius: 5px;
}
.insure>>>.el-input--suffix .el-input__inner,
.insure>>>.el-input__inner {
  height: 28px;
}
.insure>>>.el-select>>>.el-input__inner{
  border-radius: 5px;
}
.block >>> .el-slider__runway,
.el-slider >>> .el-slider__runway{
   margin: 7px 0;
}
.btns .el-button{
  width: 160px;
  height: 35px;
  line-height: 0;
}
.imgBg{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #efefef;
  margin-top: 20px;
}
.imgBg>>>img{
  width: 40px;
  margin: 13px 10px;
}
.width-190{
  width: 190px!important;
}
.width-150{
  width: 150px!important;
}
.custom-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
/*.el-loading-mask {*/
/*  z-index: 2000 !important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/ResultNew.vue